import { setUserAgent } from './modules/ua'
import { sliderInit } from './modules/slider'
import { headerSetting } from './modules/header'
import { cartPageInit } from './modules/cartPage'
import { productGiftSetting } from './modules/product'
import { productStoryModalProcessing } from './modules/modal'
import { formDisabled } from './modules/formDisabled'

const loadCommonInit = () => {
  // 全ページ共通適用
  setUserAgent()
  sliderInit()
  headerSetting()
  productGiftSetting()
  productStoryModalProcessing()
  formDisabled()
  cartPageInit()
}

window.addEventListener('load', () => {
  loadCommonInit()
  document.querySelector('html').classList.add('is-loaded')
})

/**
 * ▶ を '&#9654;' に置換
 */
const replaceEmojiWithEntity = () => {
  /**
   * ドキュメント内の全テキストノードを取得するためのヘルパー関数
   * @param node
   * @param arr
   * @returns {*[]}
   */
  const getTextNodes = (node, arr = []) => {
    node.childNodes.forEach((child) => {
      if (child.nodeType === 3) {
        arr.push(child)
      } else {
        getTextNodes(child, arr)
      }
    })
    return arr
  }

  // ドキュメント内の全テキストノードを取得
  const textNodes = getTextNodes(document.body)

  // 各テキストノードを処理
  textNodes.forEach((node) => {
    // '▶️' を '&#9654;' に置換
    const span = document.createElement('span')
    span.innerHTML = node.nodeValue.replace(/▶️/g, '&#9654;')
    if (span.innerHTML !== node.nodeValue) {
      node.parentNode.replaceChild(span, node)
    }
  })
}

// ドキュメントが読み込まれたら関数を実行
document.addEventListener('DOMContentLoaded', replaceEmojiWithEntity)
